import { useBooleanFlagValue } from "@openfeature/react-sdk";

import { useGetCurrentBusinessPlan } from "./useGetCurrentBusinessPlan";

/**
 * Check if the domain matching settings are enabled for the current business
 */
export const useIsDomainMatchingSettingEnabled = (businessId?: string): boolean | undefined => {
  const domainMatchingSettingsFlag = useBooleanFlagValue("show-domain-matching-settings", false);
  const { isTeamPlan, loading } = useGetCurrentBusinessPlan(businessId);

  const domainMatchingEnabledForDomain = (!loading && !isTeamPlan) ?? false;

  if (!businessId || loading) {
    return undefined;
  }

  return domainMatchingEnabledForDomain && domainMatchingSettingsFlag;
};
